// 記事リストの配列
const database = [
  {
    id: 201806090,
    name: '映像・アニメーション表現#1 「靴の大冒険！」',
    date: '2018.06.09',
    img: 'http://img.youtube.com/vi/TEwXn47JAYo/maxresdefault.jpg',
    content:
    `
      <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/TEwXn47JAYo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <p>
        映像・アニメーション表現の授業課題としてコマ撮り動画を作成しました。一部のBGMは自分で作った曲を使用しています。
      </p>
      <p>
        使用ソフト(動画): iMovie
      </p>
      <p>
        使用ソフト(作曲): GarageBand
      </p>
    `,
    moreInfo: 'https://youtu.be/TEwXn47JAYo',
    tag: 'work',
    tag2: 'others'
  },
  {
    id: 2021070110,
    name: 'iPhone版なんでもインスタ映え',
    date: '2021.07.11',
    img: 'http://naoto.nkmr.io/images/iPhone版なんでもインスタ映え.PNG',
    content:
    `
      <video src="http://naoto.nkmr.io/images/iPhone版なんでもインスタ映え.mp4" controls></video>
      <p>
        Swiftの勉強のために作ったiPhone向け画像加工アプリです。
        画面遷移やクラスといった基本的なことを学ぶことができ、同時にCore Imageといった画像処理用のAPIについても学ぶことができました。
      </p>
    `,
    moreInfo: '',
    tag: 'work',
    tag2: 'programming'
  },
  {
    id: 202107060,
    name: '【LIVE】sumika Live Tour 2021『花鳥風月』',
    date: '2021.07.06',
    img: 'http://naoto.nkmr.io/images/sumika_202107.png',
    content:
    `
      <img src="http://naoto.nkmr.io/images/sumika_202107.png" oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;'></img>
      <p>
        2021年7月6日に東京ガーデンシアターで開催されたsumikaのライブに参加しました。
        sumikaの曲はノリが良くて楽しい曲が多く、とても盛り上がりました！
        5階のバルコニー席だったため、ライブの演出を上からじっくりと観察できて楽しかったです。
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'live'
  },
  {
    id: 202107030,
    name: 'ホームページをマイナーチェンジしました！',
    date: '2021.07.03',
    img: 'http://naoto.nkmr.io/images/semistian.png',
    content:
    `
      <p>
        当サイトのデザインをマイナーチェンジしました。
        今後も見やすいホームページの制作に努めてまいりますので、どうぞよろしくお願いします。
      </p>
    `,
    moreInfo: '',
    tag: 'info',
    tag2: ''
  },
  {
    id: 202106130,
    name: '【エレクトーン】エレクトーンフェスティバル2021店大会に出場しました。',
    date: '2021.06.13',
    img: 'http://naoto.nkmr.io/images/ef2021_mise.png',
    content:
    `
      <img src="http://naoto.nkmr.io/images/ef2021_mise.png" oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;'></img>
      <p>
        2021年6月13日に開催されたエレクトーンフェスティバル2021店大会に出場しました。
      </p>
      <p>
        ソロ部門では「Englishman in New York」、アンサンブル部門では「TAKE FIVE」を演奏しました。
      </p>
      <p>
        どちらの部門でも銀賞を受賞しました。残念ながら神奈川大会には出場できませんでしたが、とても楽しく演奏することができました。
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'electone'
  },
  {
    id: 201907140,
    name: '【エレクトーン】エレクトーンフェスティバル2019ソロ部門神奈川大会に出場しました。',
    date: '2019.07.14',
    img: 'http://naoto.nkmr.io/images/ef2019_solo.JPG',
    content:
    `
      <img src="http://naoto.nkmr.io/images/ef2019_solo.JPG" oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;'></img>
      <p>
        2019年7月14日に開催されたエレクトーンフェスティバル2019ソロ部門神奈川大会に出場しました。
      </p>
      <p>
        前回に引き続き、マリンバが特徴的な「風の行方」を演奏しました。
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'electone'
  },
  {
    id: 201906020,
    name: '【エレクトーン】エレクトーンフェスティバル2019店大会に出場しました。',
    date: '2019.06.02',
    img: 'http://naoto.nkmr.io/images/ef2019_mise.JPG',
    content:
    `
      <img src="http://naoto.nkmr.io/images/ef2019_mise.JPG" oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;'></img>
      <p>
        2019年6月2日に開催されたエレクトーンフェスティバル2019店大会に出場しました。
      </p>
      <p>
        ソロ部門ではマリンバが特徴的な「風の行方」、アンサンブル部門では「現実との3分間」を演奏しました。
      </p>
      <img src="http://naoto.nkmr.io/images/ef2019_mise2.JPG" oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;'></img>
      <p>
        どちらも金賞を受賞し、ソロ部門では神奈川大会に出場することが決定しました！
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'electone'
  },
  {
    id: 201812260,
    name: '【エレクトーン】エレクトーンフェスティバル2018アンサンブル部門神奈川大会に出場しました。',
    date: '2018.12.26',
    img: 'http://naoto.nkmr.io/images/ef2018_group.png',
    content:
    `
      <img src="http://naoto.nkmr.io/images/ef2018_group.png" oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;'></img>
      <p>
        2018年12月26日に開催されたエレクトーンフェスティバル2018アンサンブル部門神奈川大会に出場しました。
      </p>
      <p>
        前回に引き続き、「Piano concerto in F」を演奏しました。
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'electone'
  },
  {
    id: 201807150,
    name: '【エレクトーン】エレクトーンフェスティバル2018ソロ部門神奈川大会に出場しました。',
    date: '2018.07.15',
    img: 'http://naoto.nkmr.io/images/ef2018_solo.JPG',
    content:
    `
      <img src="http://naoto.nkmr.io/images/ef2018_solo.JPG" oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;'></img>
      <p>
        2018年7月15日に開催されたエレクトーンフェスティバル2018ソロ部門神奈川大会に出場しました。
      </p>
      <p>
        前回に引き続き、Koba作曲の「K Jungle」を演奏しました。
      </p>
      <img src="http://naoto.nkmr.io/images/ef2018_solo2.JPG" oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;'></img>
      <p>
        本大会では、なんと銀賞を受賞することができました！
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'electone'
  },
  {
    id: 201806030,
    name: '【エレクトーン】エレクトーンフェスティバル2018店大会に出場しました。',
    date: '2018.06.03',
    img: 'http://naoto.nkmr.io/images/ef2018_mise.JPG',
    content:
    `
      <img src="http://naoto.nkmr.io/images/ef2018_mise.JPG" oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;'></img>
      <p>
        2018年6月3日に開催されたエレクトーンフェスティバル2018店大会に出場しました。
      </p>
      <p>
        ソロ部門ではアコーディオンが特徴的な「K Jungle」、アンサンブル部門では「Piano concerto in F」を演奏しました。
      </p>
      <p>
        どちらも金賞を受賞し、神奈川大会への出場が決定しました！
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'electone'
  },
  {
    id: 201712270,
    name: '【エレクトーン】エレクトーンフェスティバル2017アンサンブル部門神奈川大会に出場しました。',
    date: '2017.12.27',
    img: 'http://naoto.nkmr.io/images/ef2017_group.JPG',
    content:
    `
      <img src="http://naoto.nkmr.io/images/ef2017_group.JPG" oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;'></img>
      <p>
        2017年12月27日に開催されたエレクトーンフェスティバル2017アンサンブル部門神奈川大会に出場しました。
      </p>
      <p>
        前回に引き続き、「SISTER SADIE」を演奏しました。
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'electone'
  },
  {
    id: 201707160,
    name: '【エレクトーン】エレクトーンフェスティバル2017ソロ部門神奈川大会に出場しました。',
    date: '2017.07.16',
    img: 'http://naoto.nkmr.io/images/ef2017_solo.JPG',
    content:
    `
      <img src="http://naoto.nkmr.io/images/ef2017_solo.JPG" oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;'></img>
      <p>
        2017年7月16日に開催されたエレクトーンフェスティバル2017ソロ部門神奈川大会に出場しました。
      </p>
      <p>
        前回に引き続き、「The deep time on the seaside」を演奏しました。
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'electone'
  },
  {
    id: 201706040,
    name: '【エレクトーン】エレクトーンフェスティバル2017店大会に出場しました。',
    date: '2017.06.04',
    img: 'http://naoto.nkmr.io/images/ef2017_mise.JPG',
    content:
    `
      <img src="http://naoto.nkmr.io/images/ef2017_mise.JPG" oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;'></img>
      <p>
        2017年6月4日に開催されたエレクトーンフェスティバル2017店大会に出場しました。
      </p>
      <p>
        ソロ部門では「The deep time on the seaside」、アンサンブル部門では「SISTER SADIE」を演奏しました。
      </p>
      <p>
        どちらも金賞を受賞し、神奈川大会への出場が決定しました！
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'electone'
  },
  {
    id: 201606050,
    name: '【エレクトーン】エレクトーンフェスティバル2016店大会に出場しました。',
    date: '2016.06.05',
    img: 'http://naoto.nkmr.io/images/ef2016_mise.JPG',
    content:
    `
      <img src="http://naoto.nkmr.io/images/ef2016_mise.JPG" oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;'></img>
      <p>
        2016年6月5日に開催されたエレクトーンフェスティバル2016店大会に出場しました。
      </p>
      <p>
        アンサンブル部門で、「Elbow Greace」を演奏しました。
      </p>
      <p>
        本大会では銀賞を受賞することができました！
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'electone'
  },
  {
    id: 202106230,
    name: '【LIVE】Official髭男dism Road to 「one-man tour 2021-2022」',
    date: '2021.06.23',
    img: 'http://naoto.nkmr.io/images/higedan_20210623a.jpg',
    content:
    `
      <p>
        2021年6月23日にぴあアリーナMMで開催されたOfficial髭男dism Road to 「one-man tour 2021-2022」に参加しました。
        1年4ヶ月ぶりの現地でのヒゲダンライブは歓声なしでもとても盛り上がるライブでした！
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'live'
  },
  {
    id: 202106150,
    name: '【LIVE】Fear, and Loathing in Las Vegas HYPERTOUGHNESS” Release Tour 2020→2021',
    date: '2021.06.15',
    img: 'http://naoto.nkmr.io/images/vegas_20210615a.JPG',
    content:
    `
      <p>
        2021年6月15日にKT Zepp Yokohamaで開催されたFear, and Loathing in Las Vegasのライブに参加しました。
        ラウドロック系バンドのワンマンライブは初めてでしたが、ヘドバンで激ノリになれてとても楽しかったです！
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'live'
  },
  {
    id: 202103170,
    name: '【共著】集合知を利用した音楽キュレーションサービスの実装とその分析',
    date: '2021.03.17',
    img: 'http://naoto.nkmr.io/images/ec59_illust_research.png',
    content:
    `
      <p>
        音楽が埋もれてしまうといった問題に対して、集合知を利用することにより、プレイリストを構成する手法を提案した研究です。
      </p>
      <p>
        音楽視聴者の持つユニークな音楽へのニーズに対して、それをリクエストとして投稿することで、他者が楽曲を回答してくれるという仕組みを実現しました。
        実際にシステムとしてmureQを開発し、利用状況についてユーザへのアンケートも交えながら分析を行いました。
      </p>
    `,
    moreInfo: 'https://dl.nkmr-lab.org/papers/327',
    tag: 'research',
    tag2: ''
  },
  {
    id: 202103161,
    name: '【主著】負荷の高いタスクの並列提示によるタスク遂行への負荷軽減に関する手法の提案',
    date: '2021.03.16',
    img: 'http://naoto.nkmr.io/images/hci192_illust_research.png',
    content:
    `
      <p>
        やるべきタスクに対して、それよりも負荷の高いタスクを並列提示することで、やるべきタスクの負荷を軽減し、モチベーションを向上させる研究です。
      </p>
      <p>
        実際にやるべきタスクと比較用のタスクを並列提示した場合と、しなかった場合に、タスクの遂行率に差が出るかどうかについて実験を行いました。
        その結果、提案手法によって、提示しなかった時や同じ系統のタスクの時にタスクの遂行率が向上することが示唆されました。
      </p>
    `,
    moreInfo: 'https://dl.nkmr-lab.org/papers/321',
    tag: 'research',
    tag2: ''
  },
  {
    id: 202103160,
    name: '第192回HCI研究会にてリモート発表を行いました！',
    date: '2021.03.16',
    img: 'http://naoto.nkmr.io/images/semistian.png',
    content:
    `
      <p>
        2021年3月15日〜16日にオンラインにて開催された第192回HCI研究会に参加しました。参加報告記事も書かせていただいたので、そちらも合わせてご覧ください。
      </p>
    `,
    moreInfo: 'http://nkmr-lab.org/news/hci192_task_matasuyama.html',
    tag: 'info',
    tag2: ''
  },
  {
    id: 202101280,
    name: '【共著】プログレスバーと周辺の視覚刺激の進行方向が体感時間に与える影響',
    date: '2021.01.28',
    img: 'http://naoto.nkmr.io/images/hci191_illust_research.png',
    content:
    `
      <p>
        プログレスバーの周辺に視覚刺激を提示することで、体感時間に影響が出るかについて調査を行った研究です。
      </p>
      <p>
        プログレスバーの進行方向が水平方向であることに着目し、視覚刺激の進行方向を水平方向にすると体感時間に影響を及ぼすのではないかと考え、さまざまなパターンの視覚刺激を提示する実験を行いました。
        その結果、プログレスバーと同じ進行方向に光点が運動する視覚刺激を提示することによって体感時間が短縮され、プログレスバーの進行方向と逆向きに運動する正弦波の視覚刺激を提示することによって体感時間が延長されることを明らかになりました。
      </p>
    `,
    moreInfo: 'https://dl.nkmr-lab.org/papers/294',
    tag: 'research',
    tag2: ''
  },
  {
    id: 202009041,
    name: '【エレクトーン】MIU404メインテーマ（Short ver.）弾いてみた【MIU404】',
    date: '2020.09.04',
    img: 'http://img.youtube.com/vi/goY609ODYN4/maxresdefault.jpg',
    content:
    `
      <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/goY609ODYN4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <p>
      </p>
    `,
    moreInfo: 'https://youtu.be/goY609ODYN4',
    tag: 'work',
    tag2: 'electone'
  },
  {
    id: 202009040,
    name: '【エレクトーン】メロンパンのうた【MIU404】',
    date: '2020.09.04',
    img: 'http://img.youtube.com/vi/vpQpkb73YnE/maxresdefault.jpg',
    content:
    `
      <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/vpQpkb73YnE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <p>
      </p>
    `,
    moreInfo: 'https://youtu.be/vpQpkb73YnE',
    tag: 'work',
    tag2: 'electone'
  },
  {
    id: 202005260,
    name: '【エレクトーン】あつまれどうぶつの森　メインテーマ【あつ森】',
    date: '2020.05.26',
    img: 'http://img.youtube.com/vi/9cT6Ol7mVy4/maxresdefault.jpg',
    content:
    `
      <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/9cT6Ol7mVy4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <p>
      </p>
    `,
    moreInfo: 'https://youtu.be/9cT6Ol7mVy4',
    tag: 'work',
    tag2: 'electone'
  },
  {
    id: 202002160,
    name: '【LIVE】米津玄師 2020 TOUR / HYPE',
    date: '2020.02.16',
    img: 'http://naoto.nkmr.io/images/yonezu_20200216aJPG',
    content:
    `
      <p>
        2020年2月16日〜11日に横浜アリーナで開催された米津玄師のライブに参加しました。
        席がステージにとても近く、至近距離に米津さんが来てくれてとても嬉しかったです！
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'live'
  },
  {
    id: 202002110,
    name: '【LIVE】Official髭男dism Tour 19/20 Hall Travelers',
    date: '2020.02.11',
    img: 'http://naoto.nkmr.io/images/higedan_20200211a.jpg',
    content:
    `
      <p>
        2020年2月10日〜11日にパシフィコ横浜国立大ホールで開催されたOfficial髭男dismのライブに2DAYS参加しました。
        どんな不安なことがあっても、ヒゲダンの音楽を聴いて乗り切ろうと思えるライブでした！
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'live'
  },
  {
    id: 201911100,
    name: '【LIVE】赤い公園 FUYU TOUR 2019 Yo-Ho',
    date: '2019.11.10',
    img: 'http://naoto.nkmr.io/images/akaikoen_20191110a.jpg',
    content:
    `
      <p>
        2019年11月10日にEX THEATER ROPPONGIで開催された赤い公園のライブに参加しました。
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'live'
  },
  {
    id: 201909110,
    name: '【LIVE】BUMP OF CHICKEN aurora ark',
    date: '2019.09.11',
    img: 'http://naoto.nkmr.io/images/bump_20190911a.png',
    content:
    `
      <p>
        2019年9月11日に京セラドーム大阪で開催されたBUMP OF CHICKENのライブに参加しました。
        初の遠征ライブでした！
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'live'
  },
  {
    id: 201907170,
    name: '【LIVE】ポルカドットスティングレイ 2019 有頂天ツアーファイナル',
    date: '2019.07.17',
    img: 'http://naoto.nkmr.io/images/polka_20190717a.png',
    content:
    `
      <p>
        2019年7月17日に日本武道館で開催されたポルカドットスティングレイのライブに参加しました。
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'live'
  },
  {
    id: 201907080,
    name: '【LIVE】Official髭男dism tour 2019',
    date: '2019.07.08',
    img: 'http://naoto.nkmr.io/images/higedan_20190708a.png',
    content:
    `
      <p>
        2019年7月8日に日本武道館で開催されたOfficial髭男dismのライブに参加しました。
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'live'
  },
  {
    id: 201901270,
    name: '【LIVE】米津玄師 When the Spine Becomes Opal',
    date: '2019.01.27',
    img: 'http://naoto.nkmr.io/images/yonezu_20190127a.png',
    content:
    `
      <p>
        2019年1月27日に横浜アリーナで開催された米津玄師のライブに参加しました。
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'live'
  },
  {
    id: 201709170,
    name: '【LIVE】BUMP OF CHICKEN PATHFINDER TOUR 2017-2018',
    date: '2017.09.17',
    img: 'http://naoto.nkmr.io/images/bump_20170917a.JPG',
    content:
    `
      <p>
        2017年9月17日日に幕張メッセで開催されたBUMP OF CHICKENのライブに参加しました。
      </p>
    `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'live'
  },
  {
    id: 201808100,
    name: 'mureQ',
    date: '2018.08.10',
    img: 'http://naoto.nkmr.io/images/mureq.png',
    content:
    `
      <img src = '' oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;' />
      <p>
        所属研究室で行われたハッカソンでの製作物です。
        アイデア出しと、フロントエンド、デザイナーとして初期段階の製作に関わりました。
        このシステムはReact.jsを用いて実装しました。
      </p>
    `,
    moreInfo: 'https://mureq.com/',
    tag: 'work',
    tag2: 'programming'
  },
  {
    id: 202003170,
    name: '【主著】メッセージ画面のスクリーンショットを用いた横断型返信忘れ防止手法の検討',
    date: '2020.03.17',
    img: 'http://naoto.nkmr.io/images/gn110_illust_research.png',
    content:
      `
        <p>
          コミュニケーションツールにおいて返信しなければいけないメッセージに対して、画像として探せるサムネイル生成手法の検討を行った研究です。
        </p>
        <p>
          カジュアルな会話とフォーマルな会話を想定した架空のメッセージ画像を記憶したのち、サムネイル画像を提示し想起する実験を行いました。
          その結果、フォーマルな場面において、アイコン画像とメッセージテキストの一部を切り取ったものが有用である可能性が示唆されました。
        </p>
      `,
    moreInfo: 'https://dl.nkmr-lab.org/papers/238',
    tag: 'research',
    tag2: ''
  },
  {
    id: 202003171,
    name: '第110回GN研究会にてリモート発表を行いました！',
    date: '2020.03.17',
    img: 'http://naoto.nkmr.io/images/semistian.png',
    content:
      `
        <p>
          2020年3月16日〜17日にオンラインにて開催された第110回GN研究会に参加しました。参加報告記事も書かせていただいたので、そちらも合わせてご覧ください。
        </p>
      `,
    moreInfo: 'http://nkmr-lab.org/news/gn110_reminder_matsuyama.html',
    tag: 'info',
    tag2: ''
  },
  {
    id: 202003070,
    name: '【旅行】2020.03 大阪・神戸・有馬',
    date: '2020.03.07',
    img: 'http://naoto.nkmr.io/images/kobe_20200302a.jpg',
    content:
      `
        <img src = 'http://naoto.nkmr.io/images/kobe_20200302a.jpg' oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;' />
        <p>
          2020年3月に、大阪と神戸・有馬へ旅行に行きました。
        </p>
        <p>
          コロナの影響でUSJは楽しむことができませんでしたが、大阪と神戸南京町のグルメや神戸のオシャレな街並み、有馬の温泉を楽しむことができてよかったです！
        </p>
      `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'trip'
  },
  {
    id: 202003020,
    name: '【旅行】2020.02-03 金沢・福井',
    date: '2020.03.02',
    img: 'http://naoto.nkmr.io/images/kanazawa.jpg',
    content:
      `
        <img src = 'http://naoto.nkmr.io/images/kanazawa.jpg' oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;' />
        <p>
          2020年2月〜3月に、石川と福井へ旅行に行きました。
        </p>
        <p>
          金沢のおいしい海鮮丼やカレー、小京都の町並みや景勝地を楽しむことができました！
        </p>
      `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'trip'
  },
  {
    id: 202002260,
    name: '【旅行】2020.02 城崎',
    date: '2020.02.26',
    img: 'http://naoto.nkmr.io/images/kinosaki.jpg',
    content:
      `
        <img src = 'http://naoto.nkmr.io/images/kinosaki.jpg' oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;' />
        <p>
          2020年2月に、城崎温泉へ旅行に行きました。
        </p>
        <p>
          7つの外湯めぐりで卒論の疲れをゆっくり癒すことができました。
        </p>
      `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'trip'
  },
  {
    id: 201909040,
    name: '【旅行】2019.09 宮城',
    date: '2019.09.04',
    img: 'http://naoto.nkmr.io/images/sendai_201909a.jpg',
    content:
      `
        <img src = 'http://naoto.nkmr.io/images/sendai_201909a.jpg' oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;' />
        <p>
          2019年9月に、宮城へひとり旅をしに行きました。
        </p>
        <p>
          杜の都・仙台と作並温泉、日本三景のひとつである松島の美しい景色を堪能することができました。
        </p>
      `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'trip'
  },
  {
    id: 201902270,
    name: '【旅行】2019.02 大阪',
    date: '2019.02.27',
    img: 'http://naoto.nkmr.io/images/osaka_2019.JPG',
    content:
      `
        <img src = 'http://naoto.nkmr.io/images/osaka_2019.JPG' oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;' />
        <p>
          2019年2月に、大阪へ旅行に行きました。
        </p>
        <p>
          USJや海遊館、吉本新喜劇など、大阪ならではのエンターテインメントを楽しむことができました！
        </p>
      `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'trip'
  },
  {
    id: 201809120,
    name: '【旅行】2018.09 金沢・高岡',
    date: '2018.09.12',
    img: 'http://naoto.nkmr.io/images/hokuriku_201809a.JPG',
    content:
      `
        <img src = 'http://naoto.nkmr.io/images/hokuriku_201809a.JPG' oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;' />
        <p>
          2018年9月に、北陸へ旅行に行きました。
        </p>
        <p>
          北陸のおいしい海鮮丼や、金沢の古き良き町並み、雨晴海岸の情緒ある風景を楽しんできました！
        </p>
      `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'trip'
  },
  {
    id: 201809070,
    name: '【旅行】2018.09 浜松・名古屋・岐阜',
    date: '2018.09.07',
    img: 'http://naoto.nkmr.io/images/hamamatsu_201809a.JPG',
    content:
      `
        <img src = 'http://naoto.nkmr.io/images/hamamatsu_201809a.JPG' oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;' />
        <p>
          2018年9月に、浜松と名古屋と岐阜へひとり旅をしに行きました。
        </p>
        <p>
          初めての泊まりでのひとり旅でした。グルメや楽器、雄大な自然を楽しむことができて、自由気ままに楽しむことができるひとり旅の魅力に気づけました！
        </p>
      `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'trip'
  },
  {
    id: 201802150,
    name: '【旅行】2018.02 箱根',
    date: '2018.02.15',
    img: 'http://naoto.nkmr.io/images/hakone_2018.JPG',
    content:
      `
        <img src = 'http://naoto.nkmr.io/images/hakone_2018.JPG' oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;' />
        <p>
          2018年2月に、箱根へ旅行に行きました。
        </p>
        <p>
          温泉や芦ノ湖・大涌谷といった箱根ならではの観光に加え、森林の中の本格的アスレチックといった変わったアクティビティを満喫してきました！
        </p>
      `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'trip'
  },
  {
    id: 201709060,
    name: '【旅行】2017.09 京都・大阪',
    date: '2017.09.06',
    img: 'http://naoto.nkmr.io/images/osaka_201709a.JPG',
    content:
      `
        <img src = 'http://naoto.nkmr.io/images/osaka_201709a.JPG' oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;' />
        <p>
          2017年9月に、京都と大阪へ旅行に行きました。
        </p>
        <p>
          グルメでは抹茶や豆乳鍋、串カツ、観光では京都の自社仏閣や初のUSJを楽しんできました！
        </p>
      `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'trip'
  },
  {
    id: 201911050,
    name: '【合同研究会】中村研・関西大松下研合同研究会2019',
    date: '2019.11.07',
    img: 'http://naoto.nkmr.io/images/kansaidai_2019.jpg',
    content:
      `
        <img src = 'http://naoto.nkmr.io/images/kansaidai_2019.jpg' oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;' />
        <p>
          2019年11月5日〜7日に、関西大学にて中村研と関西大松下研の合同研究会が行われました。
        </p>
      `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'labo'
  },
  {
    id: 201905260,
    name: '【合宿】中村研究室合宿2019 猪苗代',
    date: '2019.05.26',
    img: 'http://naoto.nkmr.io/images/gassyuku_inawashiro.JPG',
    content:
      `
        <img src = 'http://naoto.nkmr.io/images/gassyuku_inawashiro.JPG' oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;' />
        <p>
          2019年5月24日〜26日に、猪苗代にて中村研究室の合宿が行われました。
        </p>
      `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'labo'
  },
  {
    id: 201811050,
    name: '【合同研究会】中村研・関西大松下研合同研究会2018',
    date: '2018.11.05',
    img: 'http://naoto.nkmr.io/images/kansaidai_2018.jpg',
    content:
      `
        <img src = 'http://naoto.nkmr.io/images/kansaidai_2018.jpg' oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;' />
        <p>
          2018年11月3日〜5日に、関西大学にて中村研と関西大松下研の合同研究会が行われました。
        </p>
      `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'labo'
  },
  {
    id: 201805270,
    name: '【合宿】中村研究室合宿2018 千葉・白浜',
    date: '2018.05.27',
    img: 'http://naoto.nkmr.io/images/kamogawa.png',
    content:
      `
        <img src = 'http://naoto.nkmr.io/images/kamogawa.png' oncontextmenu='return false;' onselectstart='return false;' onmousedown='return false;' />
        <p>
          2018年5月25日〜27日に、千葉・白浜にて中村研究室の合宿が行われました。
        </p>
        <p>
          太平洋を望む白浜の景色を堪能しながら、2018年度の研究テーマについてとても有意義な議論を行うことができました。最終日は、鴨川シーワールドにてグループライフログのための観光写真撮影に努めました。
        </p>
      `,
    moreInfo: '',
    tag: 'diary',
    tag2: 'labo'
  },
  {
    id: 201910270,
    name: '第2回コミック工学研究会に参加しました！',
    date: '2019.10.27',
    img: 'http://naoto.nkmr.io/images/semistian.png',
    content:
      `
        <p>
          2019年10月25日〜26日に開催された第2回コミック工学研究会に参加しました。
          参加報告記事も書かせていただいたので、そちらも合わせてご覧ください。
        </p>
      `,
    moreInfo: 'http://nkmr-lab.org/news/cc2_comic_report.html',
    tag: 'info',
    tag2: ''
  },
  {
    id: 201908011,
    name: '松山直人オフィシャルサイト',
    date: '2019.08.01',
    img: 'http://naoto.nkmr.io/images/matsuken_homepage.png',
    content:
    `
      <p>
        このサイトを作りました。実装はVue.jsを用いて行いました。
      </p>
    `,
    moreInfo: '',
    tag: 'work',
    tag2: 'programming'
  },
  {
    id: 201908010,
    name: 'ホームページをリニューアルしました！',
    date: '2019.08.01',
    img: 'http://naoto.nkmr.io/images/semistian.png',
    content:
      `
        <p>
          この度ホームページのリニューアルを行いました。
          これからもどうぞよろしくお願いします。
        </p>
      `,
    moreInfo: '',
    tag: 'info',
    tag2: ''
  },
  {
    id: 201907180,
    name: '大学院に合格しました！',
    date: '2019.07.18',
    img: 'http://naoto.nkmr.io/images/semistian.png',
    content:
      `
        <p>
          2020年度より明治大学先端数理科学研究科先端メディアサイエンス専攻に進学します。
        </p>
      `,
    moreInfo: '',
    tag: 'info',
    tag2: ''
  },
  // {
  //   id: 201902270,
  //   name: '2019.02.25-27 大阪旅行',
  //   date: '2019.02.27',
  //   img: '',
  //   content:
  //     `
  //       <p>
  //         2020年度より明治大学先端数理科学研究科先端メディアサイエンス専攻に進学します。
  //       </p>
  //     `,
  //   moreInfo: '',
  //   tag: 'diary',
  //   tag2: 'trip'
  // },
  {
    id: 201812050,
    name: '【主著】ユーザの視線情報分析に基づく現実空間のBADUI検出に関する検討',
    date: '2018.12.05',
    img: 'http://naoto.nkmr.io/images/illust_research_BADUI.png',
    content:
    `
      <img src="http://naoto.nkmr.io/images/illust_research_BADUI.png" oncontextmenu="return false;" onselectstart="return false;" onmousedown="return false;">
      <p>
        視線情報から現実空間におけるBADUIを検出可能かどうかを検証した研究です。
      </p>
      <p>
        BADUIを操作した際の視線情報を取得・分析を行った結果、
        BADUIの操作に迷ったユーザと迷わなかったユーザでは視線の動きや視線交差回数に差が生じ、
        このことより視線情報からBADUIの操作に迷っているユーザを検出できる可能性が示唆されました。
      </p>
      <p>
        なお、この研究について2018年12月4日〜5日に開催された情報処理学会第180回HCI研究会にて登壇発表を行い、
        学生奨励賞を受賞しました。
      </p>
    `,
    moreInfo: 'http://nkmr-lab.org/news/hci180_badui_eye_matsuyama.html',
    tag: 'research',
    tag2: ''
  },
  {
    id: 201701160,
    name: 'みのるくんのひみつのおえかき',
    date: '2017.01.16',
    img: 'http://naoto.nkmr.io/images/Minorukun2.png',
    content:
    `
      <img src="http://naoto.nkmr.io/images/Minorukun2.png" oncontextmenu="return false;" onselectstart="return false;" onmousedown="return false;">
      <p>
        大学1年生のプログラミング演習のグループワークでの製作物です。
        お題が表示され、そのお題に沿って絵を描くクイズ形式のペイントツールです。このシステムはProcessingで実装しました。
        なお、このシステムについて、2017年1月16日に学科内で開催されたプログラミング演習にて発表しました。
      </p>
    `,
    moreInfo: '',
    tag: 'work',
    tag2: 'programming'
  },
  {
    id: 201801100,
    name: 'なんでもインスタ映え',
    date: '2018.01.10',
    img: 'http://naoto.nkmr.io/images/insta_bae.png',
    content:
    `
      <img src="http://naoto.nkmr.io/images/insta_bae.png" oncontextmenu="return false;" onselectstart="return false;" onmousedown="return false;">
      <p>
        大学2年生のCMP演習のグループワークでの製作物です。
        画像にフィルターをかけたり、絵を描いたりできる画像加工ツールです。このシステムはJavaScriptで実装しました。
        なお、このシステムについて、2018年1月10日に学科内で開催されたCMP演習にて発表しました。
      </p>
    `,
    moreInfo: '',
    tag: 'work',
    tag2: 'programming'
  },
  {
    id: 201605300,
    name: 'HSPカラオケ',
    date: '2016.05.30',
    img: 'http://naoto.nkmr.io/images/HSPkaraoke.png',
    content:
    `
      <img src="http://naoto.nkmr.io/images/HSPkaraoke.png" oncontextmenu="return false;" onselectstart="return false;" onmousedown="return false;">
      <p>
        FMSに入学して最初に作ったプログラムです。
        2016年5月30日に学科内で開催されたEP演習にて発表しました。
      </p>
    `,
    moreInfo: '',
    tag: 'work',
    tag2: 'programming'
  }
]
// インポート先で使用できる関数をオブジェクトとしてまとめたもの
export default {
  fetch(id) {
    return database
  },
  find(id) {
    return database.find(el => el.id === id)
  },
  asyncFind(id, callback) {
    setTimeout(() => {
      callback(database.find(el => el.id === id))
    }, 1000)
  }
}
